var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLidoLogoWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 159,
    viewBox: "0 0 500 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9019_1756)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4737 19.5L92.6051 66.3811L62.4737 83.824L32.3423 66.3811L62.4737 19.5ZM41.5596 64.1538L62.4737 31.6295L83.3878 64.1538L62.4737 76.2565L41.5596 64.1538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4465 94.1287L27.4908 73.895L26.5475 75.3709C15.794 92.1161 18.1927 114.04 32.3151 128.102C48.944 144.633 75.9221 144.633 92.5779 128.102C106.727 114.04 109.126 92.1161 98.3455 75.3709L97.4022 73.895L62.4465 94.1287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.508 111.947H173.755V48.0527H185.883V100.677H213.508V111.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.472 111.947H262.344V48.0527H274.472V111.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.63 111.947V48.0527H344.41C347.563 48.0527 350.123 48.16 352.064 48.4015C357.077 48.9919 361.416 50.763 365.027 53.6881C368.693 56.6131 371.469 60.37 373.355 64.9589C375.269 69.5208 376.212 74.539 376.212 80.0134C376.212 85.4878 375.269 90.506 373.355 95.0948C371.442 99.6568 368.666 103.387 365.027 106.312C361.389 109.237 357.077 111.008 352.064 111.598C350.096 111.84 347.536 111.947 344.41 111.947H323.63ZM344.41 100.596C347.563 100.596 349.881 100.435 351.363 100.14C354.031 99.6031 356.268 98.3419 358.047 96.3561C359.853 94.3434 361.2 91.9283 362.063 89.0837C362.952 86.2124 363.41 83.18 363.41 79.9866C363.41 76.7932 362.952 73.6266 362.036 70.7553C361.146 67.8839 359.799 65.4687 357.966 63.5098C356.187 61.5508 353.977 60.3164 351.363 59.8333C349.881 59.5381 347.563 59.3771 344.41 59.3771H335.947V100.569H344.41V100.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.061 113.289C442.728 113.289 437.23 111.921 432.513 109.157C427.824 106.366 424.212 102.475 421.679 97.4297C419.173 92.4115 417.933 86.5883 417.933 79.9868C417.933 73.3853 419.173 67.5621 421.679 62.5439C424.212 57.5257 427.824 53.6346 432.513 50.8706C437.203 48.0797 442.728 46.7111 449.061 46.7111C455.395 46.7111 460.893 48.1065 465.609 50.8706C470.299 53.6346 473.91 57.5257 476.39 62.5439C478.923 67.5621 480.19 73.3853 480.19 79.9868C480.19 86.5883 478.923 92.4115 476.39 97.4297C473.883 102.448 470.299 106.366 465.609 109.157C460.92 111.921 455.395 113.289 449.061 113.289ZM449.412 101.938C453.347 101.938 456.635 101.026 459.303 99.2276C461.971 97.4297 463.992 94.8803 465.313 91.6064C466.661 88.3325 467.307 84.4683 467.307 80.0136C467.307 73.1438 465.744 67.7768 462.591 63.9125C459.438 60.0482 454.802 58.0893 448.684 58.0893C444.749 58.0893 441.461 59.0017 438.793 60.7996C436.125 62.5976 434.104 65.1469 432.783 68.4208C431.435 71.6947 430.789 75.559 430.789 80.0136C430.789 86.8834 432.352 92.2505 435.505 96.1148C438.658 99.979 443.294 101.938 449.412 101.938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9019_1756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460.326,
    height: 121,
    fill: "white",
    transform: "translate(19.8369 19.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLidoLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lido_logo_white.aadbe7d36e6e336c4fb8ab8740a43e96.svg";